import { useTranslation } from "react-i18next";
import "../../../styles/mapStyles/Popup.css";

function GetSoilInfoBtn({ getSoilInfo, loading }) {
  const { t } = useTranslation();
  return (
    <button className="get-soil-info-btn" onClick={getSoilInfo} disabled={loading}>
      {loading ? t("soil.fetchingSoilData") : t("soil.getSoilInformation")}
    </button>
  );
}

export default GetSoilInfoBtn;
